import React, { memo } from 'react';

import Popup from '../helpers/Popup';
import Button from '../helpers/Button';
import FormGroup from '../helpers/FormGroup';

const DeleteRestartedAgreementPopupComponent = ({ isDisabled, sourceForAgreement, onChange, onDelete, onClose }) => {
  const header = 'Agreement Deletion Confirmation';

  const footer = (
    <>
      <Button className="btn-danger" disabled={isDisabled} onClick={onDelete} type="button">
        Delete
      </Button>
      <Button key="close" data-dismiss="modal" onClick={onClose}>
        Close
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header={header} id="deleteAgreementPopup">
      <div className="row">
        <div className="col-sm-12">
          {sourceForAgreement?.map(item => (
            <div key={item.get('companyRetainerId')} className="mb4">
              &quot;<i>{item.get('contractualName')}</i>&quot; an Addendum/Assignment attached to this agreement.
            </div>
          ))}
          <p>What would you like to do?</p>
          <div>
            <FormGroup>
              <div className="radio-wrap radio-wrap--reverse">
                <label className="font-normal" htmlFor="deleteHardLinkedAgreements">
                  Delete all linked agreements?
                </label>
                <input
                  id="deleteHardLinkedAgreements"
                  name="deleteAgreement"
                  onChange={onChange}
                  type="radio"
                  value="hard"
                />
              </div>
            </FormGroup>
            <FormGroup>
              <div className="radio-wrap radio-wrap--reverse">
                <label className="font-normal" htmlFor="deleteSoftLinkedAgreements">
                  Just delete this agreement?
                </label>
                <input
                  id="deleteSoftLinkedAgreements"
                  name="deleteAgreement"
                  onChange={onChange}
                  type="radio"
                  value="soft"
                />
              </div>
              <p className="help-block">
                The linked agreements will remain visible, but this agreement will no longer be accessible for
                reference.
              </p>
            </FormGroup>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export const DeleteRestartedAgreementPopup = memo(DeleteRestartedAgreementPopupComponent);
